import { Link } from "react-router-dom";
import { AlertCircle, ChevronRight } from "lucide-react";

export const LEGAL_INDEX = [
    { kind: "terms", title: "Términos y condiciones", path: "/legal/terminos" },
    { kind: "privacy", title: "Política de privacidad", path: "/legal/privacidad" },
    { kind: "cookies", title: "Política de cookies", path: "/legal/cookies" },
    { kind: "responsible", title: "Juego responsable", path: "/legal/juego-responsable" },
    { kind: "antifraude", title: "Política AML / Antifraude", path: "/legal/antifraude" },
    { kind: "creators_terms", title: "Términos para creadores", path: "/legal/terminos-creadores" },
];

export default function LegalPage({ kind, title, lastUpdated, sections, pendingReview = true }) {
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid={`legal-${kind}`}>
            <div className="text-xs uppercase tracking-[0.3em] text-p2w-purple font-sora font-bold">
                Legal
            </div>
            <h1 className="mt-3 font-sora font-extrabold text-4xl sm:text-5xl tracking-tighter text-white">
                {title}
            </h1>
            <div className="mt-4 text-sm text-p2w-gray">
                Última actualización: <span className="text-white">{lastUpdated}</span>
            </div>

            {pendingReview && (
                <div
                    className="mt-6 rounded-xl border border-p2w-amber/40 bg-p2w-amber/10 px-4 py-3 flex items-start gap-3"
                    data-testid="legal-pending-notice"
                >
                    <AlertCircle className="w-4 h-4 text-p2w-amber mt-0.5 shrink-0" />
                    <p className="text-sm text-p2w-amber">
                        Documento informativo; pendiente de revisión legal.
                    </p>
                </div>
            )}

            <article className="mt-10 space-y-10">
                {sections.map((s, i) => (
                    <section key={i} data-testid={`legal-section-${i}`}>
                        <h2 className="font-sora font-bold text-xl text-white tracking-tight">
                            {i + 1}. {s.h}
                        </h2>
                        <div className="mt-3 space-y-3 text-[15px] leading-7 text-white/85">
                            {s.body.map((p, j) =>
                                Array.isArray(p) ? (
                                    <ul key={j} className="list-disc pl-5 space-y-1.5 text-white/80 marker:text-p2w-green">
                                        {p.map((li, k) => <li key={k}>{li}</li>)}
                                    </ul>
                                ) : (
                                    <p key={j}>{p}</p>
                                )
                            )}
                        </div>
                    </section>
                ))}
            </article>

            <nav className="mt-16 pt-8 border-t border-p2w-line" data-testid="legal-other-policies">
                <div className="text-xs uppercase tracking-[0.2em] text-p2w-gray font-sora font-bold">
                    Otras políticas
                </div>
                <ul className="mt-4 space-y-1">
                    {LEGAL_INDEX.filter((p) => p.kind !== kind).map((p) => (
                        <li key={p.kind}>
                            <Link
                                to={p.path}
                                data-testid={`legal-nav-${p.kind}`}
                                className="group flex items-center justify-between rounded-lg border border-transparent hover:border-p2w-line hover:bg-p2w-surface px-3 py-2.5 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p2w-green"
                            >
                                <span className="text-sm text-white/80 group-hover:text-p2w-green">{p.title}</span>
                                <ChevronRight className="w-4 h-4 text-p2w-gray group-hover:text-p2w-green transition" />
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
}
